import { StyledOptionButton } from './styles';
import { OptionButtonProps } from './types';

export const OptionButton: React.FC<OptionButtonProps> = ({ text, selected, onClick }) => {
  return (
    <StyledOptionButton selected={selected} onClick={onClick} text={''}>
      {text}
    </StyledOptionButton>
  );
};
